<!--  -->
<template>
  <v-os-popup
    :show="isShow"
    :title="showTab.name"
    @close="close"
    :footerShow="false"
    class="vPopup"
    container="body"
    :height="isLowAndroid ? '80vh' : 'auto'"
  >
    <div class="installment-container" :class="{'multiple': showTab.isShow}" aria-hidden="false">
      <!-- 分期详情 -->
      <div class="table-container">
        <!-- 切换tab -->
        <div class="tab-area" v-if="showTab.isShow">
          <div
            class="tab-item"
            :class="selectTab == 1 ? 'selected' : ''"
            tabindex="0"
            v-if="huabeiPerInstallmentInfoList.length"
            @click="changeTab(1)"
          >
            <img class="pic huaBei" src="./img/huaBei.png" :alt="selectTab == 1 ? '已选中,' : '未选中'" />
            <span class="name">花呗分期</span>
          </div>
          <div
            class="tab-item"
            :class="selectTab == 2 ? 'selected' : ''"
            tabindex="0"
            v-if="bankInstallmentList.length"
            @click="changeTab(2)"
          >
            <img class="pic creditCard" src="./img/creditCard.png" :alt="selectTab == 2 ? '已选中,' : '未选中'" />
            <span class="name">信用卡分期</span>
          </div>
          <div
            class="tab-item"
            :class="selectTab == 3 ? 'selected' : ''"
            tabindex="0"
            v-if="selfInstallmentList.length"
            @click="changeTab(3)"
          >
            <img class="pic vivoCard" src="./img/vivoCard.png" :alt="selectTab == 3 ? '已选中,' : '未选中'" />
            <span class="name">丰融分期</span>
            <span class="tag" v-if="installment.detail.selfInstallment.creditCorner">{{ installment.detail.selfInstallment.creditCorner }}</span>
          </div>
        </div>
        <div class="tab-list" role="list" v-show="selectTab == 1">
          <div class="tab-list-item" :class="{border1px: index != 0}" role="listitem" v-for="(item, index) in huabeiPerInstallmentInfoList" :key="index">
            <span class="list-item-title" v-text="`￥${item.perPay} × ${item.num}期`"></span>
            <span class="tag-installment" v-if="item.userTotalFeePay == 0">免息</span>
            <span class="tag-installment" v-else>含利息</span>
          </div>
        </div>
        <div class="tab-list" role="list" v-show="selectTab == 2">
          <div class="tab-list-item" :class="{border1px: index != 0}" role="listitem" v-for="(item, index) in bankInstallmentList" :key="index">
            <img :src="item.bankLogoPic" alt="" />
            <span class="list-item-title" v-if="item.bankName" v-text="`${item.bankName}信用卡`"></span>
            <span class="list-item-title-1" v-if="item.userCard" v-text="`(${item.userCard})`"></span>
            <span class="tag-installment" v-text="item.label"></span>
          </div>
        </div>
        <div class="installment-status" v-if="vivoCardStatus && vivoCardUrl" v-show="selectTab == 3">
          <span class="text" v-if="vivoCardStatus == 1">暂未开通丰融分期，<span class="link" @click="goVivoCard(5)">去开通</span></span>
          <span class="text" v-else-if="vivoCardStatus == 2" @click="goVivoCard(7)">已开通丰融分期，可查询分期额度</span>
          <span class="text" v-else-if="vivoCardStatus == 3">丰融分期状态已过期，<span class="link" @click="goVivoCard(6)">可重新开通</span></span>
          <v-icon class="arrow-right" name="arrow-right-v3" :color="vivoCardStatus == 2 ? '#000' : '#F10313'" />
        </div>
        <div class="tab-list" role="list" v-show="selectTab == 3">
          <div class="tab-list-item" :class="{border1px: index != 0}" role="listitem" v-for="(item, index) in selfInstallmentList" :key="index">
            <span class="list-item-title" v-text="`￥${item.perPay}${isLowest} × ${item.num}期`"></span>
            <span class="tag-installment" v-if="item.userTotalFeePay == 0">免息</span>
            <span class="tag-installment" v-else>含利息</span>
          </div>
        </div>
      </div>
      <!-- 分期介绍 -->
      <div class="installment-introduce" v-if="perInstallmentLink" @click="goStag()" tabindex="0">
        <span class="text" v-text="perInstallmentDesc"></span>
        <v-icon class="arrow-right" name="arrow-right-v3" color="#ccc" />
      </div>
    </div>
  </v-os-popup>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import { mapState, mapGetters, mapActions } from 'vuex'
import { app } from '@/utils'
import env from '@/utils/clientEnv'
import { getInstallmentInfo } from '../../index/api'
export default {
  name: 'InstallmentPopup',
  //import引入的组件需要注入到对象中才能使用
  components: {},
  props: {
    isShow: {
      type: Boolean,
      default: false
    }
  },
  data() {
    //这里存放数据
    return {
      tabName: ['', '花呗分期', '银联分期', '丰融分期'],
      selectTab: 1,
      tabNum: 1,
      selfInfo: {
        status: 0,
        url: ''
      },
      isLowAndroid: env.isLowAndroid
    }
  },
  created() {
    document.addEventListener("visibilitychange", async () => {
      // 检测丰融分期跳转钱包开通后更新状态
      const isHidden = document.hidden || document.webkitHidden
      if (!isHidden && this.selfInstallmentInfo && this.isShow) {
        const salePrice = this.discountType === 'deposit' ? this.depositTotalPrice : this.totalPrice
        const info = await getInstallmentInfo({
          skuId: this.skuId,
          skuName: this.skuInfo.commoditySkuBaseInfo.skuName,
          salePrice: salePrice.toFixed(2)
        })
        this.selfInfo.status = info?.creditStatus
        this.selfInfo.url = info?.applyCreditAddress
      }
    })
  },
  //监听属性 类似于data概念
  computed: {
    ...mapState('detailv3', ['skuInfo', 'installment']),
    ...mapGetters('detailv3', ['skuId', 'discountType', 'skuId', 'totalPrice', 'depositTotalPrice']),
    // 埋点参数page_name
    pageName() {
      return this.discountType == 'group' ? 2 : 1
    },
    //丰融分期信息
    selfInstallmentInfo() {
      //按照分期数进行排序
      return this.installment?.detail?.selfInstallment || null
    },
    vivoCardStatus() {
      return this.selfInfo.status || this.selfInstallmentInfo?.creditStatus
    },
    vivoCardUrl() {
      return this.selfInfo.url || this.selfInstallmentInfo?.applyCreditAddress
    },
    isLowest() {
      return this.installment?.detail?.selfInstallment?.creditStatus !== 2 ? '起' : ''
    },
    //丰融分期
    selfInstallmentList() {
      //按照分期数进行排序
      return this.installment?.detail?.selfInstallment?.perInstallmentInfoList || []
    },
    //花呗分期
    huabeiPerInstallmentInfoList() {
      //按照分期数进行排序
      return this.installment?.detail?.hbInstallment?.perInstallmentInfoList || []
    },
    //银联分期
    bankInstallmentList() {
      return this.installment?.detail?.unionPayInstallment?.bankInstallmentList || []
    },
    showTab() {
      let isShow = false
      let name = '分期优惠'
      let count = 0
      if (this.selfInstallmentList.length) {
        count += 1
        name = '丰融' + name
      }
      if (this.huabeiPerInstallmentInfoList.length) {
        count += 1
        name = '花呗' + name
      }
      if (this.bankInstallmentList.length) {
        count += 1
        name = '银联' + name
      }
      if (count >= 2) {
        isShow = true
        name = '分期优惠'
      }
      return { isShow, name}
    },
    //分期描述链接
    perInstallmentLink() {
      if (this.selectTab == 1) {
        return this.installment?.detail?.hbInstallment?.installmentLink
      } else if (this.selectTab == 2) {
        return this.installment?.detail?.unionPayInstallment?.installmentLink
      } else {
        return this.installment?.detail?.selfInstallment?.installmentLink
      }
    },
    //分期描述
    perInstallmentDesc() {
      if (this.selectTab == 1) {
        return this.installment?.detail?.hbInstallment?.installmentDesc
      } else if (this.selectTab == 2) {
        return this.installment?.detail?.unionPayInstallment?.installmentDesc
      } else {
        return this.installment?.detail?.selfInstallment?.installmentDesc
      }
    }
  },
  //监控data中的数据变化
  watch: {
    'installment.detail': {
      // 判断有几个tab页以及首次选中哪个tab
      handler: function (newValue, oldValue) {
        // 同时具备花呗和银联分期
        if (
          newValue?.hbInstallment?.perInstallmentInfoList?.length &&
          newValue?.unionPayInstallment?.bankInstallmentList?.length
        ) {
          this.tabNum = 2
        } else {
          if (newValue?.unionPayInstallment?.bankInstallmentList?.length) {
            this.selectTab = 2
          }
          this.tabNum = 1
        }
        this.selectTab = this.installment?.currentType
      },
      immediate: true
    },
    isShow: {
      handler: function (val) {
        if (val) {
          this.$track({
            event_id: '176|002|02|077',
            sku_id: this.skuId,
            page_name: this.pageName,
            tab_name: this.tabName[this.selectTab]
          })
        }
      },
      immediate: true
    },
    selectTab: {
      handler: function (val) {
        if (val&&this.isShow) {
          this.$track({
            event_id: '176|002|02|077',
            sku_id: this.skuId,
            page_name: this.pageName,
            tab_name: this.tabName[this.selectTab]
          })
        }
      },
      immediate: true
    }
  },
  //方法集合
  methods: {
    track(type) {
      this.$track({
        event_id: '176|002|01|077',
        page_name: this.pageName,
        sku_id: this.skuId,
        click_Pos: type, // 1:花呗分期tab、2:银联分期tab;3:花呗分期文字链;4:银联分期文字链;5:丰融分期tab;6:暂未开通丰融分期;7:丰融分期状态已过期，需重新开通;8:已开通丰融分期
        tab_name: this.tabName[this.selectTab]
      })
    },
    changeTab(val) {
      this.selectTab = val
    },
    close() {
      this.$emit('close')
    },
    goVivoCard(pos) {
      this.jump(this.vivoCardUrl)
      this.track(pos)
    },
    goStag() {
      this.jump(this.perInstallmentLink)
      const clickPos = [0, 3, 4, 8]
      this.track(clickPos[this.selectTab])
    },
    jump(url) {
      app.openNewWebview({ url })
    }
  }
}
</script>
<style lang="scss" src="./index.scss" scoped></style>
<style lang="scss" scoped src="../../index/dark-popup.scss"></style>
<style lang="scss" scoped>
.vivo-fontscale-4,
.vivo-fontscale-5 {
  .table-container .tab-area .tab-item .name {
    font-size: 34px;
  }
}
</style>
